export function getAppPrefs(appPrefs) {
    return { type: 'GET_APP_PREFS', appPrefs };
}
